// Phone menu crest rail (snippets/upside-nav-mobile.liquid). The rail is built when the menu opens, with lazy logos,
// so the squares sat blank for a moment. On phones, once the page is idle, fetch the logos of the first squares the
// rail shows (same order: the saved school first) so they're cached; when it opens, load the rest straight away.
(() => {
  const FIRST = 12;
  const phone = window.matchMedia('(max-width: 989px)');
  const logos = () => {
    let map = {}, mine = null;
    try { map = JSON.parse(document.getElementById('un-schools').textContent); mine = localStorage.getItem('upside-school'); } catch (e) {}
    const keys = Object.keys(map);
    if (mine && map[mine]) keys.sort((a, b) => (a === mine ? -1 : b === mine ? 1 : 0));
    return keys.map((k) => map[k].t || map[k].l).filter(Boolean);
  };
  const preload = () => {
    if (!phone.matches) return;
    logos().slice(0, FIRST).forEach((src) => { const img = new Image(); img.decoding = 'async'; img.src = src; });
  };
  const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 1500));
  if (document.readyState === 'complete') idle(preload); else window.addEventListener('load', () => idle(preload), { once: true });
  // Opened: the menu's own click handler has just built the rail (this listener runs after it, on the document);
  // no more waiting for each logo to scroll into view.
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.um__open')) return;
    document.querySelectorAll('[data-um-rail] img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
  }, { passive: true });
})();